/*
 * Replaces all potentially "breaking" space in MD Anderson with &nbsp;
 * This is a brand requirement for the MD Anderson partnership.
 *
 * IMPORTANT!
 * Must be run before all other internal JS is run as it erases event listeners
 */
document.body.innerHTML = document.body.innerHTML.replace(
  /MD Anderson/gi,
  "MD&nbsp;Anderson"
);

/*
 * Looks for a hash in the URL, and if it starts with "scroll", scroll to an
 * element with a matching ID. Done to replace browser-based anchor linking and
 * allow us to account for the navigation
 *
 * Solution adapted from https://stackoverflow.com/q/59975660
 *
 * @param (string) hash
 */
const scrollToAnchor = function (hash) {

  // Ensure hash has the '#scroll' part before executing
  const hashTemplate = "#scroll-";
  if(hash.match(hashTemplate) == null) { return; }

  // Convert #scroll- hashed ID to an element ID, then get element
  const anchor = "#" + hash.substring(hashTemplate.length);
  const target = document.querySelector(anchor);


  // Return if element DNE
  if(!target) { return; }

  // Account for navbar height to offset scroll
  const navbar = document.querySelector('#navbar-container');
  const navbarHeight = navbar ? navbar.offsetHeight + 30 : 150;
  target.style.scrollMarginTop = navbarHeight + "px";
  target.scrollIntoView();

}
// Only execute this once page is loaded
addEventListener("load", (event) => { scrollToAnchor(window.location.hash); });



/**
 * @TODO: 3/24/26, LMA
 *
 * Look through this stuff, document it. No clue what it is. Old Vaughn code
 * running on every page of every site.
 *
 */
$(document).ready(function () {

    'use strict';
    $('.pageBuilderContent iframe').on('load', function() {
        console.log('iframe loaded');
        $(this).show();
    });

    // get navs combined height (minimized height: -20px)
    let navHeight = $('#navbar-container').outerHeight() - 20;
    let bannerHeight = $('#emergency-banner').outerHeight();
    if (typeof bannerHeight == 'undefined') {
      bannerHeight = 0;
    }

    const body = document.getElementsByTagName('body')[0];
    body.style.setProperty('--nav-height', navHeight + 'px');
    body.style.setProperty('--banner-height', bannerHeight + 'px');

    if ($('.navbar').length) { // VDT -- ADDED CONDITIONAL TO CHECK FOR EXISTENCE OF .navbar

      $(window).on('scroll', _.debounce(function() {

          var currScroll = $(window).scrollTop();
          var windowHeight = $(window).height() * .5;

          bannerHeight = $('#emergency-banner').outerHeight();
          if (typeof bannerHeight == 'undefined') {
            bannerHeight = 0;
          }

          // add scrolled class when past nav
          if (currScroll >= bannerHeight) {
              $('body').addClass('scrolled');
              $('#navbar-container').addClass('fixed-top');
              // $('.wrapper.global-search--hide-on-search').removeClass('mt-0');
              $('.wrapper.global-search--hide-on-search').css({'margin-top': '125px', 'transition': 'initial'});
              // $('.wrapper.global-search--hide-on-search').css({'margin-top': `${navHeight}px`, 'transition': 'initial'});
          } else {
              $('body').removeClass('scrolled');
              $('#navbar-container').removeClass('fixed-top');
              // $('.wrapper.global-search--hide-on-search').addClass('mt-0');
              $('.wrapper.global-search--hide-on-search').css({'margin-top': 'auto', 'transition': 'none'});
          }

      }, 4));

    }

    // init tooltips
    var $tooltips = $('[data-toggle="tooltip"]');
    if ($tooltips.length) {$('[data-toggle="tooltip"]').tooltip();}

    // scroll to an accordion section
    $('.btn-accordion-section').on('click', function(e) {
      var targetObj = $(this).data('scroll-to');
      var offsetVal = $(this).data('offset-top');
      $(targetObj).on('shown.bs.collapse',  () => {
        $('html, body').animate({
          scrollTop: $(targetObj).offset().top - offsetVal
        }, 1000).promise().done( () => {
          let $firstLink = $('.card-body a', targetObj).first();
          $firstLink.trigger('focus');
        });
      })
    });

    // scroll to an accordion section already opened
    $('.btn-accordion-section-show').on('click', function(e) {
      e.preventDefault();
      var targetObj = $(this).data('scroll-to');
      var offsetVal = $(this).data('offset-top');
      $('html, body').animate({
        scrollTop: $(targetObj).offset().top - offsetVal
      }, 1000);
    });

    // scroll to an object
    $('.btn-scroll-to').on('click', function(e) {
      e.preventDefault();
      var targetObj = $(this).data('scroll-to');
      var offsetVal = $(this).data('offset-top');
      $('html, body').animate({
        scrollTop: $(targetObj).offset().top - offsetVal
      }, 1000);
    });

    // set persona indicator
    $('.persona-current').text($.cookie('och_persona_longname'));

    // click to content area

    $('.clickable-to-content').on('click', function(e) {
      $('html, body').animate({
        scrollTop: $('.content').offset().top - 108
      }, 500);
    });

    /**
     * determines if the user is on a mobile device. does not use User Agent sniffing
     * because that can't get dicey. This instead tests for features only mobile
     * devices have: small screen and a touchable screen
     * @returns boolean
     */
    const isMobile = () => {
      const smallscreen = window.matchMedia("only screen and (max-width: 760px)").matches;
      const touchevents = 'ontouchstart' in document.documentElement;
      return smallscreen && touchevents;
    }

  /**
   * didn't make a phone number in body copy a clickable link?
   * no problem! let's fix that right up
   * there is an insane regex below that i will attempt to explain
   * it'll match all 11 digit numbers (1-504-123-4567), 10 digit numbers (504-123-4567)
   * and 7 digit numbers (123-4567) that have either a hyphen or space separator
   * (so it'll match 1 504-123-4567, 1 504 123 4567, 1-504-123-4567, and 15041234567)
   * and are not already inside of a <a> element. -gg
   */

  const findPhoneNumbers = (parent) => {
    const card = parent ?? document.querySelector('.card-body');
    if(card) {
      const cardChildren = card.childNodes;
      const regex =  /(?!<a[^>]*>[^<])\(?(\d{1})\)?[- ]?(\d{3})[- ]?(\d{3})[- ]?(\d{4})|(?![\"\>])(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}|(?![\"\>])\d{3}[\s.-]\d{4}(?![^<]*<\/a>)/gm;

      cardChildren.forEach((el) =>{
          if(el.nodeType === 3){ //text
              if(el.parentNode.tagName !== 'A'){
                  const match = regex.exec(el.textContent);
                  if(match !== null){
                      let pn = match[0];
                      let offset = match.index;
                      console.log(pn, offset);

                      let nose = el.textContent.substring(0, offset);
                      let tail = el.textContent.substring(offset + pn.length);
                      el.textContent = nose;

                      const link = document.createElement('a');
                      link.href = "tel:" + pn.replace(/[\s-]/g, '');
                      link.innerText = pn;
                      el.after(link);

                      const tailNode =document.createTextNode(tail);
                      link.after(tailNode);
                  }
              }
          }else{
              findPhoneNumbers(el)
          }
      })
    }
  }

  if(isMobile()) findPhoneNumbers();


});

/**
 * This is a wack hack to get inline links to trigger tabs.
 * Basically what you need to do is create a link like so:
 * <a href="#id_1554497_content" class="tab-toggle" data-text="Adult Track">Learn more</a>
 * The 'tab-toggle' class is what gets it captured by the below onClick
 * The 'data-text' attribute matches the text of the actual link that triggers it
 *
 * This is flimsy code but I couldn't find another way to do it. -lma
 **/
$('.tab-toggle').on('click', function(e) {
  e.preventDefault();
  let navText = $(this).attr('data-text');
  let $navLink = $("a.nav-link:contains('" + navText + "')");
  let $tab = $("#" + $navLink.attr('id'));
  $tab.tab('show');
  $("body,html").animate(
    {
      scrollTop: $('#accordion-main').offset().top
    },
    500 //speed
  );
});